import Link from 'next/link'
import React from 'react'
import type { IHomeBanner } from '@/schemas/pages'

interface IBannerProps {
    slide: IHomeBanner
    /** Primeiro banner do carrossel: é a imagem de LCP da home, carregada com prioridade. */
    isPriority?: boolean
}

/** Banner do carrossel da home: imagem e link de desktop e de mobile, cadastrados no CMS. */
const Banner: React.FC<IBannerProps> = ({ slide, isPriority = false }) => {
    const loading = isPriority ? 'eager' : undefined
    const fetchPriority = isPriority ? 'high' : undefined

    return (
        <div className="flex flex-col items-center w-full h-fit mt-0">
            <Link href={slide.urlDesktop || ''} className="w-full max-md:hidden">
                {/* biome-ignore lint/performance/noImgElement: imagem do CMS em qualquer host e proporção; o next/image exigiria host e tamanho fixos */}
                <img
                    src={slide.imageDesktop}
                    alt="Banner"
                    className="object-cover w-full h-full"
                    loading={loading}
                    fetchPriority={fetchPriority}
                />
            </Link>
            <Link href={slide.urlMobile || ''} className="hidden w-full max-md:block">
                {/* biome-ignore lint/performance/noImgElement: imagem do CMS em qualquer host e proporção */}
                <img
                    src={slide.imageMobile}
                    alt="Banner"
                    className="object-cover w-full h-full"
                    loading={loading}
                    fetchPriority={fetchPriority}
                />
            </Link>
        </div>
    )
}

export default Banner
